import React, { useEffect, useState } from "react";
import axios from "axios";
import SpeechAssessment from "../components/SpeechAssessment";

export default function FeedSession() {
  const [feedId, setFeedId] = useState(null);
  const [patientId, setPatientId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("p");
    if (!token) {
      setError("No token provided.");
      return;
    }
    axios
      .post("https://genz-staging.feeltiptop.com/api/feed/magic-link/login", { token })
      .then((res) => {
        if (res.data.success) {
          // Store the JWT for the session
          localStorage.setItem("authToken", res.data.access_token);
          setFeedId(res.data.feedId);
          setPatientId(res.data.patientId);
        } else {
          setError(res.data.message);
        }
      })
      .catch(() => {
        setError("Invalid or expired link.");
      });
  }, []);

  if (error) return <div>{error}</div>;
  if (!feedId || !patientId) return <div>Loading...</div>;

  return <SpeechAssessment feedID={feedId} patientID={patientId} />;
}
